
import React from 'react'
import { Breadcrumb } from 'react-bootstrap'

import { useProgrammation } from '../../../Hooks/UseProgrammation'

import GroupIcon from '../../SvgImages/Group';

import './Navigator.scss'

interface Props {
  parentId?: string
  parentName?: string
  parentPosition?: string
  parentType?: string
  itemId: string
  itemName: string
  itemPosition: string
  itemType: string
}

const Button = ({ className, onClick, children }: any) => {

  return (
    <div className={`item ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

const Navigator = (props: Props) => {

  const {
    parentId,
    parentName,
    parentPosition,
    parentType,
    itemId,
    itemName,
    itemPosition,
    itemType,
  } = props

  const { openItem } = useProgrammation()

  return (
    <Breadcrumb className={`navigator ${parentId ? 'with-parent' : ''}`}
      style={{ overflow: 'hidden' }}
    >
      {parentId && parentName && (
        <>
          <Breadcrumb.Item
            as={Button}
            onClick={() => openItem(parentId)}
          >
            {parentType === 'group' && <GroupIcon height={20} width={20} color="#333" />}
            {parentType === 'partida' && <span className='icon-tareas' style={{ color: 'var(--color-partida)'}}></span>}
            <span className="item-name" style={{ color: `var(--color-${parentType})`}}>
              {parentPosition}. {parentName}
            </span>
          </Breadcrumb.Item>
          <span className="separator">/</span>
        </>
      )}
      <Breadcrumb.Item className={`active ${parentId ? 'sub-item' : 'item'}`}
        as={Button}
      >
        {itemType === 'group' && <GroupIcon height={20} width={20} color="#333" />}
        {itemType !== 'group' && <span className='icon-tareas' style={{ color: `var(--color-${itemType})`}}></span>}
        <span className="item-name" style={{ color: `var(--color-${itemType})`}}>
          {itemPosition}. {itemName}
        </span>
      </Breadcrumb.Item>
    </Breadcrumb>
  )
}

export default Navigator
